import { render, staticRenderFns } from "./RegisterSettingCampaign.page.vue?vue&type=template&id=b1cb0532&"
import script from "./RegisterSettingCampaign.page.vue?vue&type=script&lang=js&"
export * from "./RegisterSettingCampaign.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports